


















import mixins from 'vue-typed-mixins';
import { DashboardTile } from '@/utils/DashboardUtils';
export default mixins().extend({
  props: {
    value: {
      type: Object as () => DashboardTile,
    },
  },
});
